<script lang="ts">
	import { quadOut } from 'svelte/easing';
	import { fly } from 'svelte/transition';

	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import SCDeposit from './SCDeposit.svelte';
	import SCWithdraw from './SCWithdraw.svelte';
	import {
		depositorWithdraw,
		smartContractWalletAddress,
		withdrawToken,
		addFundsToken
	} from '../store';
	import ScTokenInfoRow from '../utils/SCTokenInfoRow.svelte';
	import { nativeBalancesEnriched, userBalancesEnriched } from '$lib/home/store';
</script>

<div class="my-5 relative z-10">
	<GradientBorder
		gradient="bg-fx-gradient-6"
		paddingClass="p-px"
		borderRadius="rounded-lg"
		outerClassList=""
		innerClassList="bg-fx-gradient-8"
	>
		<div class="px-4 py-5">
			<div>
				{#if $smartContractWalletAddress && $userBalancesEnriched && $userBalancesEnriched[$withdrawToken]}
					{#if $depositorWithdraw == 'Deposit'}
						<ScTokenInfoRow token={$addFundsToken} balancesToParse={$userBalancesEnriched} />
					{:else}
						<ScTokenInfoRow token={$withdrawToken} balancesToParse={$userBalancesEnriched} />
					{/if}
				{:else}
					<div
						class="w-full h-16 bg-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
					/>
				{/if}
			</div>

			<div class="border my-3 border-fx-grey-600" />

			<div class="grid grid-cols-2 gap-4">
				<button
					class:active-section={$depositorWithdraw === 'Deposit'}
					class="text-fx-grey-300 bg-fx-grey-700 font-semibold text-center py-2 rounded-lg squircle-xl hover:bg-opacity-60 hover:text-fx-grey-200 transition duration-200 cursor-pointer"
					on:click={() => ($depositorWithdraw = 'Deposit')}
					on:keydown={(e) => {
						if (e.key === 'Enter') {
							$depositorWithdraw = 'Deposit';
						}
					}}
				>
					Deposit
				</button>
				<button
					class:active-section={$depositorWithdraw === 'Withdraw'}
					class="text-fx-grey-300 bg-fx-grey-700 font-semibold text-center py-2 rounded-lg squircle-xl hover:bg-opacity-60 hover:text-fx-grey-200 transition duration-200 cursor-pointer"
					on:click={() => ($depositorWithdraw = 'Withdraw')}
					on:keydown={(e) => {
						if (e.key === 'Enter') {
							$depositorWithdraw = 'Withdraw';
						}
					}}
				>
					Withdraw
				</button>
			</div>
			{#if $depositorWithdraw === 'Deposit'}
				<div
					in:fly={{
						duration: 350,
						x: 0,
						y: 10,
						opacity: 0.1,
						easing: quadOut
					}}
				>
					<SCDeposit />
				</div>
			{:else if $depositorWithdraw === 'Withdraw'}
				<div
					in:fly={{
						duration: 350,
						x: 0,
						y: 10,
						opacity: 0.1,
						easing: quadOut
					}}
				>
					<SCWithdraw />
				</div>
			{/if}
		</div>
	</GradientBorder>
</div>

<style>
	.active-section {
		@apply bg-fx-blue text-fx-grey-100;
	}
</style>
